import { Head } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import type { BreadcrumbItem } from "@/types"

import ActivityForm from "./_form"

interface Option {
  id: number
  name: string
}
interface PaymentMethod {
  value: string
  label: string
}
interface Props {
  activity: Record<string, unknown>
  activity_types: Option[]
  users: Option[]
  payment_methods: PaymentMethod[]
  errors?: Record<string, string[]>
}

const breadcrumbs: BreadcrumbItem[] = [
  { title: "Marketing Activities", href: "/marketing_activities" },
  { title: "New", href: "/marketing_activities/new" },
]

export default function New({
  activity,
  activity_types,
  users,
  payment_methods,
  errors,
}: Props) {
  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="New Marketing Activity" />
      <div className="p-6">
        <h1 className="mb-4 text-2xl font-semibold">New Marketing Activity</h1>
        <ActivityForm
          activity={activity}
          activityTypes={activity_types}
          users={users}
          paymentMethods={payment_methods}
          errors={errors}
        />
      </div>
    </AppLayout>
  )
}
